import { CHARTING_STATUSES, type ChartingStatus } from "@repo/data-store";
import { StatusBadge } from "@/shared/status/status-badge";
import { StatusIcon } from "@/shared/status/status-icon";

export { type ChartedStatus, type ChartingStatus, chartingStatusLabel, chartingStatusOf } from "@repo/data-store";

export function examChartingStatus(exam: { status: "preliminary" | "final"; started: boolean }): ChartingStatus {
  return exam.status === "final" ? "completed" : exam.started ? "inProgress" : "notStarted";
}

export function ChartingStatusBadge({ status }: { status?: ChartingStatus }) {
  const resolved = CHARTING_STATUSES[status ?? "notStarted"];
  return <StatusBadge tone={resolved.tone}>{resolved.label}</StatusBadge>;
}

/**
 * The badge's status as a glyph alone, for rows too tight for a badge. Several
 * statuses share a glyph, so the label rides along as the accessible name and
 * the hover title rather than being lost.
 */
export function ChartingStatusIcon({ status, size }: { status?: ChartingStatus; size?: number }) {
  const resolved = CHARTING_STATUSES[status ?? "notStarted"];
  return (
    <span role="img" aria-label={resolved.label} title={resolved.label} className="inline-flex shrink-0">
      <StatusIcon status={resolved.icon} size={size} />
    </span>
  );
}
